import React from 'react';
import Button from '../SelectValue/Button';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import WalletIcon from '@mui/icons-material/Wallet';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleIcon from '@mui/icons-material/People';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";

function Embrace() {
  const steps = [
    {
      icon: <WalletIcon fontSize="large" style={{ color: '#8046F2' }} />,
      title: 'Savings',
      description: 'Contribute regularly and track your progress in real-time. And earn perks from consistency',
      link: '/savings'
    },
    {
      icon: <TrendingUpIcon fontSize="large" style={{ color: '#8046F2' }} />,
      title: 'Halal Investments',
      description: 'Funds are deployed into vetted Shariah-compliant opportunities.',
      link: '/investment'
    },
    {
      icon: <AccountBalanceIcon fontSize="large" style={{ color: '#8046F2' }} />,
      title: 'Asset Financing',
      description: 'Get assets you need, pay installmentally - Without interest.',
      link: '/assetsfinancing'  
    },
    {
      icon: <PeopleIcon fontSize="large" style={{ color: '#8046F2' }} />,
      title: 'Circle',
      description: 'Save with friends and family toward a particular goal.',
      link: '/circle'
    },
  ]; 

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, 
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <div className="px-6 sm:px-24 py-8 sm:py-16 mb-20">
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-[24px] sm:text-[44px] font-[400]"
      >
        Build Wealth,{' '}
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#FF75E8] to-[#8046F2]">
          Not Just Balance
        </span>
      </motion.h1>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="mt-4 text-[14px] sm:text-[18px] font-[400] text-text-color1"
      >
        Our system helps individuals or groups collaborate to save for shared or personal goals - from
        education to umrah, asset funding to business launches - and autonomously deploys that capital
        into Shariah-compliant investments.
      </motion.p>

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-4"
      >
        {steps.map((step, index) => (
          <motion.div
            key={index}
            variants={item}
            className="flex flex-col items-center p-4 rounded-lg bg-white shadow-md hover:shadow-lg transition-shadow"
          >
            <div
              className="w-12 h-12 mb-4 rounded-full flex items-center justify-center"
              style={{ backgroundColor: '#F5F1FE' }} 
            >
              {step.icon}
            </div>
            <h3 className="text-[16px] sm:text-[18px] font-[500] text-text-color1">
              {step.title}
            </h3>
            <p className="text-[12px] sm:text-[14px] font-[400] text-center text-text-color1 mt-2">
              {step.description}
            </p>
            <div className="flex justify-center mt-4">
              <Link to={step.link}>
                <Button name="Learn More" />
              </Link>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}

export default Embrace;
